import { useState } from 'react';
import {
	ApolloClient,
	InMemoryCache,
	HttpLink,
	from,
	ApolloLink,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { store } from 'store';

import {
	setSnackbarMessage,
	setSnackbarSeverity,
} from 'reducers/global.reducer';

import { constants } from 'utils/constants';
import { useMsalAuth } from './useMsalAuth';

const useApolloClientAndMsalAuth = () => {
	const {
		accessToken,
		loginMsal,
		logout,
		isAuthenticated,
		instance,
		accounts,
		AuthenticatedTemplate,
		UnauthenticatedTemplate,
	} = useMsalAuth();

	const errorLink: ApolloLink = onError(
		({ graphqlErrors, networkError }: any) => {
			if (graphqlErrors && graphqlErrors?.length > 0) {
				graphqlErrors.map(({ message }: { message: string }) =>
					alert(`Server(Graphql) error ${message}`),
				);
			}
			if (networkError?.response?.status === 401) {
				store.dispatch(setSnackbarSeverity('error'));
				store.dispatch(
					setSnackbarMessage(
						'Your current session has expired. Please Login again!',
					),
				);
				setTimeout(() => {
					logout();
				}, 1000);

				// TODO: refresh auth token, 1st validate refreshToken. if refreshToken is invalid logout user else fetch new token from response
			}
		},
	);

	const authLink = setContext((_, { headers }) => {
		// Use the accessToken from MSAL for the authorization header
		return {
			headers: {
				...headers,
				authorization: accessToken ? `Bearer ${accessToken}` : '',
			},
		};
	});

	const link = from([
		errorLink,
		new HttpLink({ uri: `${constants('starshipUrl')}` }),
	]);

	const [client] = useState(
		() =>
			new ApolloClient({
				cache: new InMemoryCache({
					addTypename: false,
				}),
				link: authLink.concat(link),
				defaultOptions: {
					watchQuery: {
						errorPolicy: 'all',
					},
				},
			}),
	);

	return {
		client,
		loginMsal,
		logout,
		isAuthenticated,
		instance,
		accounts,
		AuthenticatedTemplate,
		UnauthenticatedTemplate,
	};
};

export default useApolloClientAndMsalAuth;
